 
import './Projects.scss'  
import { Swiper, SwiperSlide } from 'swiper/react'; 

// For 3D carousel
import 'swiper/css';
import 'swiper/css/effect-cube';
import 'swiper/css/pagination';
import 'swiper/css/navigation'; 
import 'swiper/css/autoplay'; 
import { Autoplay, EffectCube, Pagination, Navigation } from 'swiper/modules';
 
import projectList from "./projects.json"

import Project from '../Project';
import type { Swiper as SwiperType } from "swiper";
import { forwardRef, useImperativeHandle, useRef } from 'react';
 
type ProjectsProps = { 
};

export interface ProjectsHandle {
  goToProject(name: string): void;
  pause(): void;
  resume(): void;
}


// export default function Projects(ref : ProjectsHandle) {  
export const Projects = forwardRef<ProjectsHandle, ProjectsProps>((props, ref) => { 
    
    let swiperRef = useRef<SwiperType | null>(null);
    console.log("Projects swiper", swiperRef); 
  
    useImperativeHandle(ref, () => ({
      goToProject(name: string) {
        if (!swiperRef.current) return
        let i : number = projectList.indexOf(name);
        if (i < 0) return
        swiperRef.current.slideTo(i);
      },
  
      pause() {
        if (!swiperRef.current) return
        swiperRef.current.autoplay.stop();
      },
  
      resume() {
        if (!swiperRef.current) return
        swiperRef.current.autoplay.start();
      }
    }));

  return ( <div className="project-swiper"> 
    <Swiper
      onSwiper={(swiper : SwiperType) => {
        swiperRef.current = swiper;
      }}
      effect={'cube'}
      grabCursor={true}
      cubeEffect={{
        shadow: true,
        slideShadows: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      }} 
      rewind={true} 
      navigation={true}
      autoplay={{
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter : true
      }}
      pagination={{
        clickable: true,
      }}
      modules={[Autoplay, EffectCube, Pagination, Navigation]}
      className="project-swiper"
  > 
      {projectList.map( (names, i) => 
        <SwiperSlide key={i}>
          <Project filePath={"/projects/"+names+".md"} onAlbumToggle={(isOpen : boolean) => { 
            if (!swiperRef || !swiperRef.current) return; 
            if (isOpen) { 
              swiperRef.current.autoplay.stop();
            } else { 
              swiperRef.current.autoplay.start();
            }
          }}></Project>
        </SwiperSlide>
      )} 
      {/* <SwiperSlide> 
        <Project filePath="/projects/sphere_gen.md"></Project>
      </SwiperSlide>   */}
    </Swiper>  
    </div>
  ); 
});


